// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1RRyF","title":"InfoRow_title__2n5Ex"};